export default "__VITE_ASSET__nshiCWd0__ 1920w";